<template>
<div class="container">
    <div class="row">
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="handleBackHomeButton" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <!-- <div class="col-12 mt-3 pl-0 d-flex align-items-center">
            <h3 class="c-ndarkthree mb-0 break">
                <span class="bold">Dados da empresa</span>
                <span class="c-ndarkthree"> | </span>
                {{ $store.state.register.company.name | formatName }}
            </h3>
            <CompanyTypeStatus :companyType="$store.state.register.company.cnpj.companyType"/>
        </div> -->
        <RegisterHeader />
        <BoxRegister @saveChange="saveChanges">
            <div class="col-12 mt-4 mb-2 pl-0">
                <h4 class="c-ndarkfour regular">
                    <strong>Endereço</strong> | {{ $store.state.register.partner.name | formatName }}
                </h4>
            </div>
            <div class="col-12 border-box px-5" v-if="registeredAddress">
                <el-form :model="addressInfo" ref="addressInfo" :class="blockInputs">
                    <div class="row d-flex align-items-center">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkfour medium">
                                Endereço da empresa
                            </p>
                        </div>
                        <div class="col-12">
                            <div class="row mt-3">
                                <div class="col-6">
                                    <el-form-item prop="street">
                                        <InputText v-model="addressInfo.zipCode" label="CEP" placeholder="99999-999" v-mask="'#####-###'"/>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <el-form-item prop="street">
                                        <InputText v-model="addressInfo.street" label="Endereço" placeholder="Av. Paulista" />
                                    </el-form-item>
                                </div>
                                <div class="col-6">
                                    <el-form-item prop="district">
                                        <InputText v-model="addressInfo.district" label="Bairro" placeholder="Bela Vista" />
                                    </el-form-item>
                                </div>

                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <el-form-item prop="city">
                                        <InputText v-model="addressInfo.city" label="Cidade" placeholder="São Paulo" />
                                    </el-form-item>
                                </div>
                                <div class="col-6">
                                    <el-form-item prop="state">
                                        <InputText v-model="addressInfo.state" label="Estado" placeholder="SP" />
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row mt-3">
                                <div class="col-3">
                                    <el-form-item prop="number">
                                        <InputText v-model="addressInfo.number" label="Número" placeholder="677" />
                                    </el-form-item>
                                </div>
                                <div class="col-8">
                                    <el-form-item prop="complement">
                                        <InputText v-model="addressInfo.complemet" label="Complemento" placeholder="Complemento" />
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="col-12 border-box px-5" v-else>
                <el-form :model="addressInfo" ref="addressInfo" :class="blockInputs">
                    <div class="row d-flex align-items-center">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkthree medium">
                                Endereço
                            </p>
                        </div>
                        <div class="col-8">
                            <el-form-item prop="cep">
                                <InputText v-model="searchedCep" label="CEP" placeholder="99999-999" v-mask="'#####-###'"/>
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <Button :color="getPrimaryColor" type="outline" v-on:click.stop.prevent="searchCep">Consultar CEP</Button>
                        </div>
                    </div>
                    <div v-show="searchRequested">
                        <div v-if="cepOk" class="mb-5">
                            <div class="row mt-4">
                                <div class="col-4">
                                    <caption class="d-flex align-items-center">
                                        cep
                                    </caption>
                                    <p class="medium c-ndarkfour">
                                        {{ cep }}
                                    </p>
                                </div>
                                <div class="col-4">
                                    <caption class="d-flex align-items-center">
                                        endereço
                                    </caption>
                                    <p class="medium c-ndarkfour">
                                        {{ addressInfo.street }}
                                    </p>
                                </div>
                                <div class="col-4">
                                    <caption class="d-flex align-items-center">
                                        bairro
                                    </caption>
                                    <p class="medium c-ndarkfour">
                                        {{ addressInfo.district }}
                                    </p>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-4">
                                    <caption class="d-flex align-items-center">
                                        cidade
                                    </caption>
                                    <p class="medium c-ndarkfour">
                                        {{ addressInfo.city }}
                                    </p>
                                </div>
                                <div class="col-4">
                                    <caption class="d-flex align-items-center">
                                        estado
                                    </caption>
                                    <p class="medium c-ndarkfour">
                                        {{ addressInfo.state }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row mt-4">
                                <!-- <div class="col-12 py-3 d-flex align-items-center justify-content-start border-box">
                                    <p class="c-ndarkfour medium mb-0">
                                        Ops! Não encontramos os dados desse CEP. Por favor, insira-os abaixo.
                                    </p>
                                </div> -->
                                <div class="col-12 box-message small mb-4">
                                    <ExclamationIcon size="18" class="mx-2" color="#E19700" />
                                    <p class="c-ndarkfour medium">
                                        Ops! Não encontramos os dados desse CEP. Por favor, insira-os abaixo.
                                    </p>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-6">
                                    <el-form-item prop="street">
                                        <InputText v-model="addressInfo.street" label="Endereço" placeholder="Av. Paulista" />
                                    </el-form-item>
                                </div>
                                <div class="col-6">
                                    <el-form-item prop="district">
                                        <InputText v-model="addressInfo.district" label="Bairro" placeholder="Bela Vista" />
                                    </el-form-item>
                                </div>

                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <el-form-item prop="city">
                                        <InputText v-model="addressInfo.city" label="Cidade" placeholder="São Paulo" />
                                    </el-form-item>
                                </div>
                                <div class="col-6">
                                    <el-form-item prop="state">
                                        <InputText v-model="addressInfo.state" label="Estado" placeholder="SP" />
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-3">
                                <el-form-item prop="number">
                                    <InputText v-model="addressInfo.number" label="Número" placeholder="677" />
                                </el-form-item>
                            </div>
                            <div class="col-6">
                                <el-form-item prop="complement">
                                    <InputText v-model="addressInfo.complemet" label="Complemento" placeholder="Bloco 2" />
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="col-12 my-5 px-0" v-if="$store.state.user.userAdm">
                <RegisterNavigationButtons class="px-0" @backStep="backStep" @nextStep="nextStep" @saveChange="saveChanges"/>
            </div>
            <div v-else class="col-12 d-flex align-items-center mt-5">
                <Button @click="handleBackButton" class="mr-4 px-3" type="outline" :color="getPrimaryColor">
                    <ArrowDropdown :rotate="90" :color="getPrimaryColorHex.four"/>
                    Voltar
                </Button>
                <Button v-if="!blockInputs" :color="getPrimaryColor" :disabled="!registeredAddress && !searchRequested" @click="saveChanges"> Salvar e continuar </Button>
                <Button v-else @click="nextStep" :color="getPrimaryColor"> Continuar </Button>
            </div>
        </BoxRegister>
    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="handleCloseModal" @cancelRegister="backStep" @saveChange="saveChanges"/>
</div>
</template>

<script>
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import ExclamationIcon from '@/components/icons/Exclamation'
import CancelRegister from '@/components/modals/CancelRegister'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import BoxRegister from '@/components/box/BoxRegister'
import searchCep from '@/api/searchCep'
import insertAddressPartner from '@/api/insertAddressPartner'
import getCompanyAddress from '@/api/getCompanyAddress'
import removeMask from '@/utils/removeMask'
import RegisterHeader from '@/components/register/RegisterHeader'
import statusCodesBlockInput from '@/utils/statusCodesBlockInput'
import RegisterNavigationButtons from '@/components/register/RegisterNavigationButtons'
import Vue from 'vue'

export default {
    components: {
        //CompanyTypeStatus,
        CancelRegister,
        ArrowDropdown,
        BoxRegister,
        RegisterHeader,
        ExclamationIcon,
        RegisterNavigationButtons
    },
    data() {
        return {
            backToCompanyHome: false,
            dialogVisible:false,
            searchedCep: '',
            addressInfo: {
                street: '',
                city: '',
                state: '',
                district: '',
                zipCode: '',
                number: '',
                complement: ''
            },
            searchRequested: false,
            cepOk: false,
            registeredAddress: false,
        }
    },
    watch: {
        addressInfo: {
            deep: true,
            handler() {
                if (!this.$store.state.register.formIsChanged) {
                    this.$store.commit('register/setFormIsChanged', true)

                }                
            }
        },
    },
    computed: {
        cep() {
            return `${this.addressInfo.zipCode.substring(0,5)}-${this.addressInfo.zipCode.substring(5)}`
        },
        routePrefix() {
            return this.$store.state.user.userAdm ? `/partner/${this.$route.params.idCNPJ}` : `/company/register/${this.$route.params.idCNPJ}/partner`
        },
        blockInputs() {
            return !this.$store.state.user.userAdm && statusCodesBlockInput.includes(this.$store.state.register.company.cnpj.registerComplete) ? 'input-block' : ''
        },
        isNewCompany() {
            return !!this.$route.query.new
        }
    },
    methods: {
        handleCloseModal() {
            this.dialogVisible = false
            this.backToCompanyHome = false
        },
        handleBackButton() {
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        handleBackHomeButton() {
            this.backToCompanyHome = true
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        async searchCep() {
            const result = await searchCep(this.searchedCep)
            this.searchRequested = true;
            if (result.erro == true) {
                this.addressInfo = {
                    street: '',
                    city: '',
                    state: '',
                    district: '',
                    zipCode: removeMask(this.searchedCep),
                    number: '',
                    complement: ''
                }
                this.cepOk = false

            } else {
                this.addressInfo = {
                    street: result.logradouro,
                    city: result.localidade,
                    state: result.uf,
                    district: result.bairro,
                    zipCode: removeMask(result.cep),
                    number: '',
                    complement: ''
                }
                this.cepOk = true
            }
        },
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },

        nextStep() {
            this.isNewCompany
                ? this.$router.push(`${this.routePrefix}/pj/${this.$route.params.id}/2?new=true`)
                : this.$router.push(`${this.routePrefix}/pj/${this.$route.params.id}/2`)
        },
        async saveChanges() {
            const result = await insertAddressPartner(this.$route.params.id, this.addressInfo )
            if (result.ok) {
                this.$notify({
                    title: 'Dados salvos com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                })
                this.$store.commit('register/setPartner', { addressId: result.payload.id })
                this.$store.commit('register/setFormIsChanged', true)
                if (!this.$store.state.user.userAdm) this.nextStep()
            }
        },
        backStep() {
            const route = this.backToCompanyHome ? `/company/${this.$route.path.match(/provider|buyer|sponsor/g)||''}`
                : `${this.routePrefix}/pj/${this.$route.params.id}/0`
            this.$router.push(route)
        }

    },
    async created() {
        /* const { addressId } = this.$store.state.register.partners.find(partner => (partner.id == this.$route.params.id && partner.associateType != 'Sócio' )) */
        const { addressId } = this.$store.state.register.partner
        const result = await getCompanyAddress(addressId)
        if (result.data.ok) {
            const { street, city, state, district, zipCode, number, complement } = result.data.payload
            this.addressInfo = {
                street,
                city,
                state,
                district,
                zipCode,
                number,
                complement,
            }
            this.registeredAddress = this.addressInfo.zipCode ? true : false
            this.$store.commit('register/setFormIsChanged', false)
        }
    },
    mounted() {
        Vue.nextTick(() => {
            this.$store.commit('register/setFormIsChanged', false)
        })
    }
}
        
</script>

<style lang="scss" scoped>
.banner {
    background-color: #FFF7E6;
    border-radius: 6px;
    height: 40px;
}
</style>
